import "./MenuComponent.scss";
import {NavLink, useLocation} from "react-router-dom";
import {IMenuItem} from "../../../models/menu.model";
import {CommonService} from "../../../services";
import {useEffect, useState} from "react";

interface MenuComponentProps {

}

const menuList: IMenuItem[] = [
    {
        path: CommonService._routeConfig.Dashboard(),
        title: 'Dashboard',
    },
    {
        path: CommonService._routeConfig.AppointmentList(),
        title: 'Appointments',
    },
    {
        path: CommonService._routeConfig.ClientCases(),
        title: 'Cases',
    },
    {
        path: CommonService._routeConfig.Transaction(),
        title: 'Transactions',
    },
    // {
    //     path: CommonService._routeConfig.ClientActivityLog(),
    //     title: 'Activity Log',
    // },
    // {
    //     path: CommonService._routeConfig.TestRoute(),
    //     title: 'Test',
    // }
]

// const getPath = useCallback((menuPath: string): To => {
//     const previousRoute = history && currentRoute && history[currentRoute] && history[currentRoute]?.previousRoute;
//     if (previousRoute?.split('?')[0] === menuPath && previousRoute?.split('?')[0] !== currentRoute) {
//         // dispatch(clearPreviousNav());
//         return previousRoute;
//     }
//     return menuPath;
// }, [currentRoute, history]);

const MenuComponent = (props: MenuComponentProps) => {

    const [currentRoute, setCurrentRoute] = useState<string>('');
    const location = useLocation();

    useEffect(() => {
        setCurrentRoute(location.pathname.split('/')[1]);
    }, [location])

    return (
        <div className={'menu-component'}>
            <div className='menu-list'>
                {
                    menuList.map((menu, index) => {
                        return <NavLink key={menu.title}
                                        onClick={(e) => {
                                            if (!menu.path) {
                                                CommonService.ComingSoon();
                                                e.preventDefault();
                                            }
                                        }}
                                        className={() => {
                                            if (currentRoute === '' && menu.title === 'Dashboard') {
                                                return "menu-item active";
                                            } else if (menu.title.replace(" ", "").toLowerCase() === currentRoute.replace('-', "")) {
                                                return "menu-item active";
                                            }
                                            return "menu-item";
                                        }}
                                        to={menu.path}
                                        id={`${menu.title.toLowerCase().split(' ').join('_')}_menu`}
                                        {...props}
                        >
                            <span className="menu-item-title">{menu.title}</span>
                        </NavLink>
                    })
                }
            </div>
        </div>
    );

};

export default MenuComponent;
